"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaError = exports.CheckoutError = exports.StripeError = exports.CacheError = exports.CouponError = exports.BillingError = exports.NotificationsPermissionError = exports.NotificationsError = exports.AppManifestError = exports.RecombeeError = exports.VideoError = exports.AudioError = exports.WebPaymentError = exports.SubscriptionPlanError = exports.SubscriptionError = exports.WatermelonError = void 0;
exports.getMessageFromAxiosError = getMessageFromAxiosError;
exports.getTreefortErrorsFromAxiosError = getTreefortErrorsFromAxiosError;
exports.isDuplicateKeyViolation = isDuplicateKeyViolation;
const constants_1 = require("@treefort/constants");
const is_axios_error_1 = require("./is-axios-error");
const is_object_1 = __importDefault(require("./is-object"));
function getMessageFromAxiosError(e) {
    var _a;
    if ((0, is_axios_error_1.isAxiosError)(e) && typeof ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data.message) === "string") {
        return e.response.data.message;
    }
}
function getTreefortErrorsFromAxiosError(e) {
    var _a;
    if ((0, is_axios_error_1.isAxiosError)(e)) {
        const { errors } = (_a = e.response) === null || _a === void 0 ? void 0 : _a.data;
        return (Array.isArray(errors) ? errors : []).filter((e) => (0, is_object_1.default)(e) && typeof e.code === "string" && e.code in constants_1.ERRORS);
    }
    else {
        return [];
    }
}
function isDuplicateKeyViolation(error) {
    return (0, is_object_1.default)(error) && "code" in error && error.code === "23505";
}
class WatermelonError extends Error {
    constructor(message, options) {
        super(`[Watermelon] ${message}`, options);
    }
}
exports.WatermelonError = WatermelonError;
class SubscriptionError extends Error {
    constructor(message, options) {
        super(`[Subscription] ${message}`, options);
    }
}
exports.SubscriptionError = SubscriptionError;
class SubscriptionPlanError extends Error {
    constructor(message, options) {
        super(`[Subscription Plan] ${message}`, options);
    }
}
exports.SubscriptionPlanError = SubscriptionPlanError;
class WebPaymentError extends Error {
    constructor(message, options) {
        super(`[Web Payment] ${message}`, options);
    }
}
exports.WebPaymentError = WebPaymentError;
class AudioError extends Error {
    constructor(message, options) {
        super(`[Audio] ${message}`, options);
    }
}
exports.AudioError = AudioError;
class VideoError extends Error {
    constructor(message, options) {
        super(`[Video] ${message}`, options);
    }
}
exports.VideoError = VideoError;
class RecombeeError extends Error {
    constructor(message, options) {
        super(`[Recombee] ${message}`, options);
    }
}
exports.RecombeeError = RecombeeError;
class AppManifestError extends Error {
    constructor(message, options) {
        super(`[App Manifest] ${message}`, options);
    }
}
exports.AppManifestError = AppManifestError;
class NotificationsError extends Error {
    constructor(message, options) {
        super(`[Notifications] ${message}`, options);
    }
}
exports.NotificationsError = NotificationsError;
class NotificationsPermissionError extends NotificationsError {
    constructor(status) {
        super(`Couldn't obtain permission: ${status}`);
        this.status = status;
    }
}
exports.NotificationsPermissionError = NotificationsPermissionError;
class BillingError extends Error {
    constructor(message, options) {
        super(`[Billing] ${message}`, options);
    }
}
exports.BillingError = BillingError;
class CouponError extends Error {
    constructor(message, options) {
        super(`[Coupon] ${message}`, options);
    }
}
exports.CouponError = CouponError;
class CacheError extends Error {
    constructor(message, options) {
        super(`[Cache] ${message}`, options);
    }
}
exports.CacheError = CacheError;
class StripeError extends Error {
    constructor(message, options) {
        super(`[Stripe] ${message}`, options);
    }
}
exports.StripeError = StripeError;
class CheckoutError extends Error {
    constructor(message, options) {
        super(`[Checkout] ${message}`, options);
    }
}
exports.CheckoutError = CheckoutError;
class MediaError extends Error {
    constructor(message, options) {
        super(`[Media] ${message}`, options);
    }
}
exports.MediaError = MediaError;
